<div class="md3-modal-body" [ngStyle]="modalStyle">
  <div class="layout-auto-1-auto">
    <h5 *ngIf="!predefinedAddressType" class="md3-modal-header">
      {{selectedLocation.new ? getRessource('HeaderNewLocation') : getRessource('HeaderEditLocation')}}</h5>
    <h5 *ngIf="predefinedAddressType" class="md3-modal-header">
      {{selectedLocation.new ? getRessource('PredefinedHeaderNewLocation', {label: enumSvc.getEnumerationText('AdresseTyp', selectedLocation.adr_enmIdent_AdresseTyp)})
      : getRessource('PredefinedHeaderEditLocation', {label: enumSvc.getEnumerationText('AdresseTyp', selectedLocation.adr_enmIdent_AdresseTyp)})}}
    </h5>
    <div class="content">
      <div class="grid" *ngIf="!showManuel">

        <ng-container *ngIf="!locActive">
          <p class="typo-inline-info" style="margin-top: 0.5rem">
            <i class="far fa-info-circle"></i>
            <span>
              <ul class="typo-small">
                <li>{{getRessource('HelpTextWelcome')}}</li>
                <li>{{getRessource('HelpTextSearch')}}</li>
                <li>{{getRessource('HelpTextOverview')}}</li>
                <li>{{getRessource('HelpTextDetails')}}</li>
               </ul>
            </span>
          </p>

          <div class="md-typeahead-container" style="margin: 1rem;">
            <app-searchbar (search)="onSearch($event)" placeholder="{{getRessource('LocationSearchPlaceholder')}}"></app-searchbar>
            <div class="md-typeahead-menu" *ngIf="placesList.length > 0">
              <ng-container *ngFor="let value of placesList;let i = index">
                <span (click)="onResultClick(i)"
                      class="md-typeahead-menu-item">{{value?.placePrediction?.text?.text}}</span>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="locActive">
          <div class="grid cols-2" style="margin: 0.5rem">
            <div class="grid-1-auto address-display">
              <div class="panel">
                <strong>{{selectedLocation.adrPlaceName}}</strong>
                <div>{{selectedLocation.adrStr }} {{selectedLocation.adrHNum}}</div>
                <div>
                  <span>{{selectedLocation.adrPlz }}</span>
                  <span> {{selectedLocation.adrOrt }}</span>
                </div>
                <div>{{selectedLocation.adrLand }}</div>
              </div>

              <div class="grid grid-auto-1">
                <button class="md-btn-quickedit" style="margin-right: .5rem"  (click)="changeManuel()">
                  <i class="far fa-pencil"></i>
                </button>
                <button *ngIf="selectedLocation.new || (!this.data.new && this.data?.adrLng && this.data?.adrLat)"
                        class="md-btn-quickedit"
                        (click)="resetSearch(true)">
                  <i class="far fa-trash"></i>
                </button>
              </div>
            </div>

            <div style="overflow: hidden; border: 1px solid var(--c-dark-m1); border-radius: 0.5rem; height: 200px">
              <exg-map class="hideprints hidelogo" [latitude]="selectedLocation.adrLat" [longitude]="selectedLocation.adrLng"
                       [(zoom)]="MapZoom"
                       [disableDefaultUI]="true">
                <exg-map-marker [latitude]="selectedLocation.adrLat " [longitude]="selectedLocation.adrLng">
                </exg-map-marker>
              </exg-map>
            </div>
          </div>

          <ng-container *ngIf="!predefinedAddressType">
            <app-exg-select-enumeration #VCrcptTyp
                                        [required]="true"
                                        [(value)]="selectedLocation.adr_enmIdent_AdresseTyp"
                                        [caption]="enumSvc.getFieldCaption('Adresse', 'AdresseTyp')"
                                        enumerationName="AdresseTyp"
                                        name="type"
                                        class="span-6">
            </app-exg-select-enumeration>
          </ng-container>

          <exg-textarea [(ngModel)]="selectedLocation.adrBez"
                        [caption]="enumSvc.getFieldCaption('Adresse', 'adrBez')"
                        class="span-6">
          </exg-textarea>
<!--             <exg-textarea name="locComment" [maxlength]="1024" caption="{{getRessource('CaptionComment')}}" -->
<!--                           [(ngModel)]="selectedLocation.adrComment"></exg-textarea> -->
        </ng-container>
      </div>
      <div class="grid cols-6" *ngIf="showManuel">
        <ng-container *ngIf="!predefinedAddressType">
          <app-exg-select-enumeration #VCrcptTyp
                                      [required]="true"
                                      [(value)]="selectedLocation.adr_enmIdent_AdresseTyp"
                                      [caption]="enumSvc.getFieldCaption('Adresse', 'AdresseTyp')"
                                      enumerationName="AdresseTyp"
                                      name="type"
                                      class="span-6">
          </app-exg-select-enumeration>
        </ng-container>

        <exg-input [(ngModel)]="selectedLocation.adrStr"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrStr')"
                   class="span-5">
        </exg-input>
        <exg-input [(ngModel)]="selectedLocation.adrHNum"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrHNum')"
                   class="">
        </exg-input>

        <exg-input [(ngModel)]="selectedLocation.adrZusatz"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrZusatz')"
                   class="span-6">
        </exg-input>

        <exg-input [(ngModel)]="selectedLocation.adrLkz"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrLkz')"
                   class="">
        </exg-input>
        <exg-input [(ngModel)]="selectedLocation.adrPlz"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrPlz')"
                   class="span-2">
        </exg-input>
        <exg-input [(ngModel)]="selectedLocation.adrOrt"
                   (ngModelChange)="resetGeoCode()"
                   [caption]="enumSvc.getFieldCaption('Adresse', 'adrOrt')"
                   class="span-3">
        </exg-input>

        <exg-textarea [(ngModel)]="selectedLocation.adrBez"
                      [caption]="enumSvc.getFieldCaption('Adresse', 'adrBez')"
                      class="span-6">
        </exg-textarea>
      </div>
    </div>
    <div class="spawn-reverse" style="margin-top: 0;">
      <button (click)="delete()" class="md-btn"
              *ngIf="selectedLocation?.adrID && data.showDelete">
        {{getGlobal('Delete')}}
      </button>
      <button class="md-btn" (click)="changeManuel()">{{!showManuel ? 'Manuelle Eingabe' : 'Suche'}}</button>
      <button class="md-btn" (click)="closeModal()">{{getGlobal('Cancel')}}</button>
      <button class="md-btn" [disabled]="!dirty()"
              (click)="modalAction()">{{getGlobal('Save')}}</button>
    </div>
  </div>
</div>
